module.exports = __webpack_public_path__ + "img/Skill-Profiles.769f4797.svg";